import { createSlice } from '@reduxjs/toolkit';

export const giftsSlice = createSlice({
    name: 'gifts',
    initialState: {
        allGifts: [],
    },
    reducers: {
        setAllGifts: (state, action) => {
            state.allGifts = action.payload;
        },
    },
});
export const { setAllGifts } = giftsSlice.actions;

export default giftsSlice.reducer;
